const DISTRICT_DOMAIN_PATTERN = /^(?=.{1,253}$)(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,63}$/;

export interface DistrictDomainValidationResult {
  domain: string | null;
  error: string | null;
}

export function normalizeDistrictDomain(input: string): DistrictDomainValidationResult {
  const domain = input.trim().toLowerCase();

  if (!domain) {
    return { domain: null, error: "Enter a district email domain." };
  }

  if (domain.includes("@")) {
    return { domain: null, error: "Enter a domain only, not an email address." };
  }

  if (!DISTRICT_DOMAIN_PATTERN.test(domain)) {
    return { domain: null, error: "Enter a valid domain such as d105.net." };
  }

  return { domain, error: null };
}
